(() => {
  if (window.CaffreyExpress) { window.CaffreyExpress.refresh(); return; }
  const state = { busy: false, view: 'front', observer: null, footerObserver: null, past: false, closing: false };
  const root = () => document.querySelector('[data-es-root]');
  const selected = () => root()?.querySelector('[data-es-variant]:checked');
  const text = key => root()?.dataset[key] || '';
  const motion = () => matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
  function sticky() {
    const bar = root()?.querySelector('[data-es-sticky]');
    if (bar) bar.hidden = !(state.past && !state.closing && !state.busy);
  }
  function photo() {
    const option = selected(), gallery = root()?.querySelector('[data-es-gallery]');
    const img = gallery?.querySelector('img');
    if (!option || !img) return;
    const source = option.dataset[state.view];
    const buildURL = width => { const url = new URL(source, location.origin); url.searchParams.set('width', width); return url.href; };
    img.srcset = [320,480,640,800,1000,1200,1600].map(w => `${buildURL(w)} ${w}w`).join(', ');
    img.src = source; img.alt = option.dataset[`${state.view}Alt`];
    gallery.dataset.view = state.view;
    gallery.querySelectorAll('[data-es-view]').forEach(link => {
      link.href = option.dataset[link.dataset.esView];
      if (link.dataset.esView === state.view) link.setAttribute('aria-current', 'true');
      else link.removeAttribute('aria-current');
    });
  }
  function sync(updateURL = false) {
    const option = selected(); if (!option) return;
    root().querySelectorAll('[data-es-price]').forEach(el => { el.textContent = option.dataset.price; });
    root().querySelectorAll('[data-es-selected-title]').forEach(el => { el.textContent = option.dataset.title; });
    root().querySelectorAll('[data-es-add]').forEach(button => {
      button.disabled = state.busy || option.dataset.available !== 'true';
      button.setAttribute('aria-busy', String(state.busy));
      button.textContent = state.busy ? text('adding') : option.dataset.available === 'true' ? text('add') : text('soldOut');
    });
    document.querySelectorAll('[data-es-select]').forEach(link => {
      if (link.dataset.esSelect === option.value) link.setAttribute('aria-current', 'true');
      else link.removeAttribute('aria-current');
    });
    photo();
    if (updateURL) { const url = new URL(location.href); url.searchParams.set('variant', option.value); history.replaceState({}, '', url); }
  }
  function refresh() {
    state.observer?.disconnect(); state.footerObserver?.disconnect();
    state.past = false; state.closing = false;
    const host = root(); if (!host) return;
    host.dataset.esReady = 'true'; sync(); sticky();
    const add = host.querySelector('.cf-es-add');
    if (add) {
      state.observer = new IntersectionObserver(entries => {
        state.past = !entries[0].isIntersecting && entries[0].boundingClientRect.bottom < 0; sticky();
      }); state.observer.observe(add);
    }
    const close = document.querySelector('[data-es-close]') || document.querySelector('.footer');
    if (close) {
      state.footerObserver = new IntersectionObserver(entries => {
        state.closing = entries[0].isIntersecting || entries[0].boundingClientRect.bottom < 0; sticky();
      }); state.footerObserver.observe(close);
    }
  }
  function feedback(message, error = false, withLink = false) {
    const el = root()?.querySelector('[data-es-feedback]'); if (!el) return;
    el.replaceChildren(document.createTextNode(message)); el.dataset.error = String(error);
    if (withLink) { const link = document.createElement('a'); link.href = window.routes?.cart_url || '/cart'; link.textContent = text('viewCart'); el.append(link); }
  }
  document.addEventListener('change', event => {
    if (event.target.matches('[data-es-variant]')) { state.view = 'front'; feedback(''); sync(true); }
  });
  document.addEventListener('click', event => {
    if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
    const view = event.target.closest('[data-es-view]');
    if (view && root()?.contains(view)) { event.preventDefault(); state.view = view.dataset.esView; photo(); }
    const choice = event.target.closest('[data-es-select]');
    if (choice) {
      const option = root()?.querySelector(`[data-es-variant][value="${choice.dataset.esSelect}"]`);
      if (!option) return;
      event.preventDefault(); option.checked = true; option.dispatchEvent(new Event('change', { bubbles: true }));
      root().querySelector('.cf-es-options')?.scrollIntoView({ behavior: motion(), block: 'center' });
      option.focus({ preventScroll: true });
    }
  });
  document.addEventListener('submit', async event => {
    if (!event.target.matches('[data-es-form]')) return;
    event.preventDefault();
    const form = event.target;
    if (state.busy || !form.reportValidity() || selected()?.dataset.available !== 'true') return;
    state.busy = true; sync(); sticky(); feedback('');
    let sent = false;
    try {
      const data = new FormData(form), cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      if (cart?.getSectionsToRender) {
        data.set('sections', cart.getSectionsToRender().map(section => section.id).join(','));
        data.set('sections_url', location.pathname + location.search);
        cart.setActiveElement?.(document.activeElement);
      }
      sent = true;
      const response = await fetch((window.routes?.cart_add_url || '/cart/add') + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: data });
      const result = await response.json();
      if (!response.ok || result.status) { feedback(result.description || text('error'), true); return; }
      feedback(text('added'), false, true);
      if (cart?.renderContents && result.sections) { cart.classList.remove('is-empty'); cart.renderContents(result); }
      else { location.assign(window.routes?.cart_url || '/cart'); }
    } catch { feedback(sent ? text('checkCart') : text('error'), true, sent); }
    finally { state.busy = false; sync(); sticky(); }
  });
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('shopify:section:unload', () => queueMicrotask(refresh));
  document.addEventListener('shopify:block:select', event => event.target.closest('details')?.setAttribute('open', ''));
  window.addEventListener('popstate', () => {
    const id = new URL(location.href).searchParams.get('variant');
    const option = root()?.querySelector(`[data-es-variant][value="${id}"]`);
    if (option) { option.checked = true; state.view = 'front'; sync(); }
  });
  window.CaffreyExpress = { refresh };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, { once: true });
  else refresh();
})();
